import {
  Button,
  Container,
  createStyles,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from '@material-ui/core';
import React, { FC, Fragment, useEffect, useState } from 'react';
import {
  LocationData,
  LocationDeviceAndGal,
  Devices,
} from '../../../api/infomodul/models';
import APIRequest from '../../helpers/APIRequest';
import * as infomodul from '../../../api/infomodul';
import InfoHelpDialog from '../../dialogs/InfoHelpDialog';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      marginBottom: theme.spacing(1),
      minWidth: 120,
    },
    center: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  })
);

type Props = {
  selectedLocation: LocationData | undefined;
  setSelectedLocation: React.Dispatch<
    React.SetStateAction<LocationData | undefined>
  >;
  isPending: boolean;
  setIsPending: React.Dispatch<React.SetStateAction<boolean>>;
  setLocationData: React.Dispatch<React.SetStateAction<LocationDeviceAndGal>>;
  setDeviceData: React.Dispatch<React.SetStateAction<Devices[]>>;
  runGetDevices: boolean;
  setRunGetDevices: React.Dispatch<React.SetStateAction<boolean>>;
  setMasterId: React.Dispatch<React.SetStateAction<number | undefined>>;
  updateLocationData: boolean;
};

const InfoModulHeader: FC<Props> = ({
  selectedLocation,
  setSelectedLocation,
  isPending,
  setIsPending,
  setLocationData,
  setDeviceData,
  runGetDevices,
  setRunGetDevices,
  setMasterId,
  updateLocationData,
}) => {
  const classes = useStyles();
  const [runGetLocations, setRunGetLocations] = useState(true);
  const [runGetLocationDeviceAndGal, setRunGetLocationDeviceAndGal] =
    useState(false);
  const [locations, setLocations] = useState<LocationData[]>([]);
  const [helpOpen, setHelpOpen] = useState(false);
  const [value, setValue] = useState('');

  //Changes device list
  useEffect(() => {
    if (updateLocationData) {
      setRunGetLocationDeviceAndGal(true);
    }
    setRunGetDevices(true);
    setRunGetLocationDeviceAndGal(true);
  }, [selectedLocation, setRunGetDevices, updateLocationData]);

  //Sets area from list of available locations and saves the location in setSelectedLocation
  const handleChange = (event: React.ChangeEvent<{ value: any }>) => {
    var loc = locations.filter((obj) => {
      setValue(event.target.value);
      return obj.databaseNavn === (event.target.value as string);
    });
    setSelectedLocation(loc[0]);
  };

  //Returns MasterID
  const findByName = (name: string) => {
    for (var i = 0; i < locations.length; i += 1) {
      if (locations[i].databaseNavn === name) {
        setMasterId(locations[i].masterId);
        return locations[i].masterId;
      }
    }
    return 1;
  };

  //API call to get the available location for the user
  const RequestLocations = () => {
    return (
      <APIRequest<LocationData[]>
        run={runGetLocations}
        setRun={setRunGetLocations}
        pending={isPending}
        setIsPending={setIsPending}
        req={infomodul.getLocationOverview}
        setData={setLocations}
      />
    );
  };

  //API call to get the devices and galleries for the location saved in locationData
  const RequestLocationsDeviceAndGal = () => {
    return (
      <Fragment>
        {selectedLocation && (
          <APIRequest<LocationDeviceAndGal>
            run={runGetLocationDeviceAndGal}
            setRun={setRunGetLocationDeviceAndGal}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.getLocationDeviceAndGal({
                locationId: findByName(selectedLocation.databaseNavn),
              })
            }
            setData={setLocationData}
          />
        )}
      </Fragment>
    );
  };

  //Gets devices by masterid - Used for collecting ClientHash
  const GetDeviceList = () => {
    return (
      <Fragment>
        {selectedLocation && (
          <APIRequest<any>
            run={runGetDevices}
            setRun={setRunGetDevices}
            pending={isPending}
            setIsPending={setIsPending}
            req={() =>
              infomodul.getDeviceList({
                masterId: findByName(selectedLocation.databaseNavn),
              })
            }
            setData={setDeviceData}
          />
        )}
      </Fragment>
    );
  };

  return (
    //Header Container
    <Container maxWidth={'sm'}>
      <GetDeviceList />
      <RequestLocations />
      <RequestLocationsDeviceAndGal />
      <Grid container spacing={2} className={classes.formControl}>
        <Grid item xs={12}>
          <FormControl variant="outlined" fullWidth>
            <InputLabel id="select-location-label">Vælg plads</InputLabel>
            <Select
              labelId="select-location-label"
              id="select-location"
              value={value}
              onChange={handleChange || ''}
              label="location"
            >
              {locations.map((value, i) => {
                return (
                  <MenuItem value={value.databaseNavn} key={i}>
                    {' '}
                    {value.databaseNavn}{' '}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} className={classes.center}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setRunGetLocationDeviceAndGal(true)}
          >
            Hent
          </Button>
        </Grid>
        <Grid item xs={12} className={classes.center}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setHelpOpen(true)}
          >
            Brugervejledning
          </Button>
        </Grid>
      </Grid>
      <InfoHelpDialog
        open={helpOpen}
        onClose={() => {
          setHelpOpen(false);
        }}
      />
    </Container>
  );
};

export default InfoModulHeader;
